import { ContactPersonStatus } from "../_types/workforcePresence.types";

export const shouldShowContactPresence = (
  contactType: string,
  personStatus: ContactPersonStatus | null | undefined,
): personStatus is ContactPersonStatus => {
  return (
    (contactType === "workforce" || contactType === "organizationCoworker") &&
    personStatus != null
  );
};

export const getPresenceDotColor = (
  personStatus: ContactPersonStatus,
): string => {
  if (personStatus === "available") {
    return "#22c55e";
  }

  if (personStatus === "busy" || personStatus === "ringing") {
    return "#f97316";
  }

  if (personStatus === "mobile") {
    return "#0ea5e9";
  }

  return "#94a3b8";
};

/**
 * 'mobile' means the app is closed but the device still receives call pushes. That is reachable,
 * but not the same as being in the app, so it is drawn as a phone rather than a plain dot.
 */
export const isMobileOnlyPresence = (
  personStatus: ContactPersonStatus,
): boolean => personStatus === "mobile";
